<template>
  <div class="configProjectDetail">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-top:24px">
        <el-breadcrumb-item :to="{ path: '/formalUserManage' }" style="font-size:24px">人员管理</el-breadcrumb-item>
        <el-breadcrumb-item style="font-size:24px">匹配项目点</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <el-row style="margin-top:20px;">
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="small">
          <el-form-item label="项目点：">
            <el-input v-model="searchForm.PROJECT_NAME" clearable placeholder="请输入项目点名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="search">搜索</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-button @click="openAddNewConfig">新增项目点</el-button>
    </el-row>
    <el-row style="margin-top:20px;">
      <el-table :data="tableData" stripe border style="width: 100%">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="NAME" label="姓名" min-width="80"></el-table-column>
        <el-table-column prop="PROJECT_NAME" label="项目点" min-width="45"></el-table-column>
        <el-table-column label=操作 min-width="45">
          <template slot-scope="scope">
            <el-button type="text" @click="deleteData(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row style="margin-top:20px;">
      <el-pagination style="float: right" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </el-row>
    <el-dialog title="新增项目点" center :visible.sync="addVisible" @close="addVisible = false" width="500px" :close-on-click-modal="false">
      <el-form :model="addForm" :inline="true" ref="addForm" style="margin-left: 40px;" size="small">
        <el-form-item label="项目点：" label-width="120px">
          <el-autocomplete v-model="addForm.projects" :fetch-suggestions="queryProject" placeholder="请输入内容" @select="handleProjectSelect" @blur="checkValue" clearable></el-autocomplete>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addClose">取 消</el-button>
        <el-button size="small" @click="addSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import http from '@/api/base/http';

export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      searchForm: {
        PROJECT_NAME: '',
      },
      tableData: [],
      addVisible: false,
      addForm: {
        projects: '',
        projectId: '',
      },
    };
  },
  created() {
    console.log(this.$route.params);
    this.queryDataList();
  },
  methods: {
    // 搜索
    search() {
      this.currentPage = 1;
      this.queryDataList();
    },
    // 分页
    handleCurrentChange() {
      this.queryDataList();
    },
    // 拉取数据
    queryDataList() {
      const params = {
        SERVICE_ID: '10010',
        OTYPE: 12,
        USER_ID: parseInt(sessionStorage.getItem('userId')),
        SESSION: sessionStorage.getItem('session'),
        TC_ID: sessionStorage.getItem('companyId'),
        TC_USER_ID: this.$route.params.ID,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.PROJECT_NAME) {
        params.PROJECT_NAME = this.searchForm.PROJECT_NAME;
      }
      http.post(params).then((result) => {
        this.tableData = result[0].RELATION_INFO;
        this.totalCount = result[0].TOTAL_COUNT;
        console.log(this);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 新增匹配模态框
    openAddNewConfig() {
      this.addVisible = true;
    },
    // 删除匹配
    deleteData(row) {
      console.log(row);
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '10010',
          OTYPE: 14,
          RELATION_ID: row.RELATION_ID,
        };
        http.post(params)
          .then((result) => {
            this.$message.show({ text: '删除成功', type: 'success' });
            this.queryDataList();
          }).catch((error) => {
            this.$$message.show({ text: error, type: 'error' });
          });
      }).catch((error) => {
        this.$message.show({ text: '已取消删除', type: 'warning' });
      });
    },
    // ------------------拉取项目点
    queryProject(queryProject, callBack) {
      const params = {
        SERVICE_ID: '10010',
        OTYPE: 13,
        USER_ID: parseInt(sessionStorage.getItem('userId')),
        SESSION: sessionStorage.getItem('session'),
        TC_ID: sessionStorage.getItem('companyId'),
        PROJECT_NAME: queryProject,
      };
      http
        .post(params)
        .then((result) => {
          console.log(result);
          const results = result.map((item) => {
            item.value = item.CO_NAME;
            return item;
          });
          callBack(results);
        }).catch((error) => {
          console.log(error);
        });
    },
    // ------------------项目点
    handleProjectSelect(e) {
      this.addForm.projects = e.PROJECT_NAME;
      this.addForm.projectId = e.PROJECT_ID;
    },
    checkValue() {
    },
    addClose() {
      this.addVisible = false;
      this.addForm = {
        projects: '',
        projectId: '',
      };
    },
    addSubmit() {
      console.log(this.addForm);
      const params = {
        SERVICE_ID: '10010',
        OTYPE: 15,
        USER_ID: parseInt(sessionStorage.getItem('userId')),
        SESSION: sessionStorage.getItem('session'),
        TC_ID: sessionStorage.getItem('companyId'),
        TC_USER_ID: this.$route.params.ID,
      };
      if (this.addForm.projectId) {
        params.PROJECT_ID = this.addForm.projectId;
      } else {
        this.$message.show({ text: '请选择项目点', type: 'error' });
        return false;
      }
      http.post(params)
        .then((result) => {
          this.$message.show({ text: '操作成功', type: 'success' });
          this.queryDataList();
          this.addVisible = false;
          this.addForm = {
            projects: '',
            projectId: '',
          };
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configProjectDetail.vue